import { useCallback, useState } from 'react';
import axios from 'axios';
import notify, { MESSAGES } from '../../../utils/notify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';

const useSubmitImprovement = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitImprovement = useCallback(async ({ idOffer } = {}) => {
    if (!idOffer) {
      notify.error('Offer ID is missing. Refresh the page and try again.');
      return false;
    }

    const token = getAuthToken();
    if (!token) {
      notify.error(MESSAGES.authRequired);
      return false;
    }

    setIsSubmitting(true);
    try {
      await axios.post(
        `${api.API_URL}/procurement/ImprovementClarificationSubmitImprovement`,
        { idOffer },
        {
          headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      notify.success('Improvement submitted successfully.');
      return true;
    } catch (err) {
      notify.apiError(err, 'submit improvement');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return { submitImprovement, isSubmitting };
};

export default useSubmitImprovement;
